import React from 'react'
import styles from "./Modal.module.css"
import pdfIcon from "../../assets/pdf-icon.png"
// import downloadIcon from "../../assets/download-icon.png"
import { useNavigate } from 'react-router-dom'

const Modal = ({setShowModal, flag,loading, name}) => {
  const navigate = useNavigate();
  const handlePlan=()=>{
    localStorage.removeItem('userData');
    localStorage.removeItem('clientInvestmentData');
    navigate('/client-details')

  }
  return (
    <>
    <div className={styles.main}>
    <div className={styles.mainModal}>
       <p className={styles.cross} onClick={()=>setShowModal(false)} >X</p>
        <div className={styles.heading}>{`Congratulations, ${name}'s retirement plan is ready!`}</div>
         <div className={styles.pdfImage}>
          <img src={pdfIcon} alt="pdfImage" />
         </div>
         <p className={styles.downloadText}>{flag ? 'Download Successful' : 'Download started...'}</p>
           {loading && 
                  <div className={` spinner-border text-danger ${styles.loaderDiv}`} role="status">
                  <span className="sr-only"></span>
                  </div>}
         {/* <div className={styles.download}><small>if not, click below</small><span className={styles.downloadLink}> <img src={downloadIcon} alt="downloadIcon" /><a href="">Download</a></span></div> */}
         <div>
          <button onClick={handlePlan} className={styles.planBtn}>Prepare a New Plan</button>
         </div>
    </div>
    </div>
    </>
  )
}

export default Modal